<template>
  <image-aside-slide
    v-if="category.head_image"
    v-bind:image-src="category.head_image"
    v-bind:image-width="category.head_image_width"
    v-bind:image-height="category.head_image_height"
    v-bind:image-alt="category.title"
    v-bind:image-link="getImageLink(category)"
    v-bind:preferred-image-position="getImagePosition(category)"
    v-bind:auto-full-screen="false"
    v-bind:tag="tag"
  >
    <catalog-category-text-block
      v-bind:category="category"
      v-bind:link="getCategoryLink(category)"
      v-bind:full-screen="false"
    ></catalog-category-text-block>
  </image-aside-slide>
  <catalog-category-text-block
    v-else
    v-bind:category="category"
    v-bind:link="getCategoryLink(category)"
    v-bind:full-screen="true"
    v-bind:tag="tag"
  ></catalog-category-text-block>
</template>

<script>
import ImageAsideSlide from './utils/ImageAsideSlide'
import CatalogCategoryTextBlock from
  './catalog-category-banner/CatalogCategoryTextBlock'

export default {
  name: 'CatalogCategoryBanner',
  props: {
    category: { type: Object },
    linkText: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'section'
    }
  },
  components: {ImageAsideSlide, CatalogCategoryTextBlock},
  data: function () {
    return {}
  },
  methods: {
    getImagePosition: function (category) {
      if (category.description_position === 'left') {
        return 'right'
      } else if (category.description_position === 'right') {
        return 'left'
      } else {
        return category.description_position
      }
    },
    getCategoryRoute: function (category) {
      const params = Object.assign(
        { category: category.alias },
        this.$route.params
      )
      return {
        name: 'CatalogCategoryPage',
        params: params
      }
    },
    getCategoryLink: function (category) {
      const link = {
        route: this.getCategoryRoute(category),
        text: this.linkText
      }
      return (this.linkText) ? link : null
    },
    getImageLink: function (category) {
      return (this.linkText) ? this.getCategoryRoute(category) : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/the-content/CatalogCategoryBanner.vue